import React , { useState , useEffect}   from "react";
import { useSelector , useDispatch} from "react-redux";


import { setLeadsfiltres , setChoiceliste ,setFiltrescom } from "../../state/redux";

import CalendarTwoPickers from '../../Components/Calendar/CalendarTwoPickers' ; 
import ButtonSimple from "../../Components/Buttons/ButtonSimple";

import { formatdatemini } from "../../utils/utils_dates";
import { axios_clients_findcustomclients } from "../../axios/axios_clients";

import './DashboardFiltres.scss'

const listestatus  = {'contact':'Contact','devisenvoye': 'Devis envoyé','attente_signature':'Signature en attente','attente_documents':'Documents en attente','gagne':'Gagné'};
const listeinteractions ={'nrp':'Ne répond pas','rdv':'Rendez-vous','relance': 'Relance','echec':'Echec'} ;



const classNames = require('classnames');
function DashboardFiltres(){
    const dispatch = useDispatch() ;
    const campagnes= useSelector(state=>state.leads.campagnes);
    const {leadsfiltres,  choiceliste , filtrescom}= useSelector(state=>state.leads);
    const [filtres, setFiltres] = useState({'status':null, 'interaction' :null ,'campagne':null , 'hot':0 ,'date1':(new Date((new Date()).setMonth((new Date()).getMonth()-6))).setHours(0,0,0),'date2':(new Date()).setHours(0,0,0)})
   
   const [displaytwocalendars, setDisplaytwocalendars]  = useState(false);
   const [displaybottomfiltres, setDisplaybottomfiltres]  = useState(false);


   useEffect(()=>{setFiltres({...filtrescom})},[])
  
    const selectstatus =(x)=>(<div  key={x} className="filtreselect" onClick={()=>{x===filtres?.['status']?setFiltres({...filtres, 'status': null}) :setFiltres({...filtres, 'status': x}) }}  >
                                    <div className={classNames("filtreselect_check",{"selectedcheck":filtres?.['status']===x })} ></div>
                                    <div className="filtreselect_texte">{listestatus[x]}</div>
                            </div>);
                                                                             
    const selectinteraction =(x)=>(<div  key={x} className="filtreselect"  onClick={()=>{x===filtres?.['interaction']?setFiltres({...filtres, 'interaction': null}) :setFiltres({...filtres, 'interaction': x}) }} >
                                    <div className={classNames("filtreselect_check",{"selectedcheck":filtres?.['interaction']===x })} ></div>
                                    <div className="filtreselect_texte">{listeinteractions[x]}</div>
                           </div>);
                                                                          
    const selectcampagne =(x)=>(<div  key={x} className="filtreselect"  onClick={()=>{x===filtres?.['campagne']?setFiltres({...filtres, 'campagne': null}) :setFiltres({...filtres, 'campagne': x}) }} >
        <div className={classNames("filtreselect_check",{"selectedcheck":filtres?.['campagne']===x })} ></div>
        <div className="filtreselect_texte"> {x}  </div>
    </div>);
                                                                   
    const selecthot =()=>(<div  key='hot' className="filtreselect"   onClick={()=>{filtres?.['hot']===1?setFiltres({...filtres, 'hot': 0}) :setFiltres({...filtres, 'hot': 1}) }} >
        <div className={classNames("filtreselect_check",{"selectedcheck":filtres?.['hot']===1 })} ></div>
        <div className="filtreselect_texte"> Leads Chauds  </div>
    </div>);

   const filtrer = async()=>{   setDisplaytwocalendars(false) ; 
                        let allfiltres ={'choicestatus':filtres?.['status'],'choiceinteraction':filtres?.['interaction'],'choicecampagne':filtres?.['campagne'],'choicehot':filtres?.['hot'],'date1':filtres?.['date1'],'date2':filtres?.['date2']} ; 
                        Object.keys(allfiltres).map(x=>allfiltres[x]===null &&  delete allfiltres[x]  )  ;   
                        setDisplaybottomfiltres(false)  ; dispatch(setChoiceliste('customchoice'))  ;
                        const response = await axios_clients_findcustomclients(allfiltres) ;
                                                dispatch(setLeadsfiltres([...response.data?.sort((a,b)=>new Date(new Date(a.date_reception) - new Date(b.date_reception)))]));
                        dispatch(setFiltrescom({...filtres}))
                    }
    
    const changecustomfiltres = ()=>{displaybottomfiltres && setDisplaytwocalendars(false) ; 
                    setDisplaybottomfiltres(!displaybottomfiltres) ;
                    dispatch(setChoiceliste('customchoice'));  }

    return(<div className="dashboardfiltres" >
                <div className="dashboardfiltres_top" >
                    <div className="dashboardfiltres_top_left" >
                        <div className="dashboardfiltres_top_toggle" onClick={changecustomfiltres}  >Plus de filtres{leadsfiltres!==null && <div  className="nbfiltres">{leadsfiltres.length}</div> }</div>
                  { choiceliste==='customchoice'  &&   <div  className="dashboardfiltres_top_btngrp" >
                               { filtres?.['status']!==null  && <div className="dashboardfiltres_top_filtre" >{listestatus[filtres?.['status']]}<div onClick={()=>{setFiltres({...filtres, 'status': null})}}></div></div>}
                                { filtres?.['interaction']!==null  && <div className="dashboardfiltres_top_filtre" >{listeinteractions[filtres?.['interaction']]}<div onClick={()=>{setFiltres({...filtres, 'interaction': null}) }}></div></div>}
                                { filtres?.['campagne']!==null  && <div className="dashboardfiltres_top_filtre" >{filtres?.['campagne']}<div onClick={()=>{setFiltres({...filtres, 'campagne': null})}}></div></div>}
                                {leadsfiltres!==null && <div className="dashboardfiltres_top_filtredate" > {formatdatemini(filtres?.['date1'])} - {formatdatemini(filtres?.['date2'])} </div>}
                        </div>}
                    </div>
                    
                    {displaytwocalendars &&  <div className="containerdashbordtwocalendars" >  <CalendarTwoPickers filtres={filtres} setFiltres={setFiltres} setDisplaytwocalendars={setDisplaytwocalendars} setGosearch={()=>{return }}/> </div>   }
                </div>
                {displaybottomfiltres &&<div className="dashboardfiltres_bottom" >
                <div className="dashboardfiltres_top_displaycalendar" onClick={()=>{setDisplaytwocalendars(!displaytwocalendars)}} > {formatdatemini(filtres?.['date1'])} - {formatdatemini(filtres?.['date2'])} </div>
                <div   className="dashboardfiltres_bottom_listes">
                        <div   className="dashboardfiltres_bottom_liste">
                            <div className="dashboardfiltres_bottom_titre" >Status</div>
                            { ['contact','devisenvoye','attente_signature','attente_documents','gagne'].map(x=>selectstatus(x))}
                        </div>
                        <div   className="dashboardfiltres_bottom_liste">
                            <div className="dashboardfiltres_bottom_titre" >Interactions</div>
                            { ['nrp','rdv','relance','echec'].map(x=>selectinteraction(x))}
                            <br />
                            {selecthot()}
                        </div>
                        <div   className="dashboardfiltres_bottom_liste">
                            <div className="dashboardfiltres_bottom_titre" >Campagnes</div>
                            { [...campagnes].map(x=>selectcampagne(x))}
                        </div>
                    </div>
                    <div className="dashboardfiltres_bottom_containtbtn">
                        <ButtonSimple color='bouton_color_orange' size='bouton_size_normal' texte="Filtrer"   onclick={filtrer}    />
                    </div>
                </div>}
          
           </div>)
}


export default DashboardFiltres